export default __webpack_public_path__ + "assets/dc16580a982407d6bd8144a160e247b5.png";